import type { Id } from '@odhaczka/core';
import { useStore } from '../../data/stores';

interface Props {
  /** Sklep, z którego skopiowano trasę (StoreModel.seededFrom). */
  fromStoreId: Id;
  /** Brak = bez „Cofnij” (kopia ręczna zastąpiła trasę, której nie da się odtworzyć). */
  onUndo?: (() => void) | undefined;
}

/** Trasa skopiowana z innego sklepu sieci i jeszcze niepotwierdzona zakupami. */
export function CopiedRouteNotice({ fromStoreId, onUndo }: Props) {
  const from = useStore(fromStoreId);
  const name = from?.name ? `„${from.name}”` : 'innego sklepu';
  return (
    <div className="m-4 flex items-center gap-2 rounded-2xl border border-violet-200 bg-violet-50 py-2 pr-2 pl-4 dark:border-violet-900/60 dark:bg-violet-900/20">
      <p className="min-w-0 flex-1 py-1 text-sm">
        Trasa skopiowana z {name}. Poprawi się po tych zakupach.
      </p>
      {onUndo && (
        <button
          type="button"
          onClick={onUndo}
          className="min-h-11 shrink-0 rounded-lg px-3 font-medium text-brand-700 active:bg-violet-100 dark:text-brand-500 dark:active:bg-violet-900/40"
        >
          Cofnij
        </button>
      )}
    </div>
  );
}
